// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCUIOXzV1Bebdt8WCKHxACUMnauFBv2818",
  authDomain: "mariacambraia-1dca7.firebaseapp.com",
  projectId: "mariacambraia-1dca7",
  storageBucket: "mariacambraia-1dca7.firebasestorage.app",
  messagingSenderId: "825979287689",
  appId: "1:825979287689:web:2c255c0195a4edb7b52e58",
  measurementId: "G-DBZR9HNCQS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics };
export default app;
